import { render, staticRenderFns } from "./FireProtectionList.vue?vue&type=template&id=493c44ec&scoped=true"
import script from "./FireProtectionList.vue?vue&type=script&lang=js"
export * from "./FireProtectionList.vue?vue&type=script&lang=js"
import style0 from "./FireProtectionList.vue?vue&type=style&index=0&id=493c44ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c44ec",
  null
  
)

export default component.exports